<template>
    <div class="row d-flex justify-content-center">
        <div class="search-result col-7 mt-4">
            <h5 class="blue-aqua">
                <slot name="title"></slot>
            </h5>
            <p class="mb-0"><slot name="description"></slot></p>
            <p class="text-right mb-0" v-if="url"><a :href="url" class="btn btn-next">Read more</a></p>
        </div>
        <hr class="col-8">
    </div>
</template>

<script>
    export default {
        props:{
            url:{
                default:"#"
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/search/ResultItem.vue